import { render, staticRenderFns } from "./CoordinatesPicker.vue?vue&type=template&id=4ac22bf8&scoped=true&lang=pug&"
import script from "./CoordinatesPicker.vue?vue&type=script&lang=js&"
export * from "./CoordinatesPicker.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatesPicker.vue?vue&type=style&index=0&id=4ac22bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac22bf8",
  null
  
)

export default component.exports